import type { NombreEncuesta, RegistroEncuesta } from './preguntas';

const CLAVE = 'rumbo:encuesta';

function vacio(ahora: number): RegistroEncuesta {
  return { primeraVez: ahora, aperturas: 0, aplazada: {}, cerrada: {} };
}

/** Lo que este móvil recuerda de las encuestas (nada personal). */
export function leerRegistro(ahora = Date.now()): RegistroEncuesta {
  try {
    const guardado = JSON.parse(localStorage.getItem(CLAVE) ?? 'null');
    if (guardado && typeof guardado.primeraVez === 'number') {
      return {
        ...vacio(ahora),
        ...guardado,
        aplazada: { ...guardado.aplazada },
        cerrada: { ...guardado.cerrada },
      };
    }
  } catch {
    // Sin almacenamiento (modo privado): se empieza de cero.
  }
  return vacio(ahora);
}

export function guardarRegistro(registro: RegistroEncuesta) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify(registro));
  } catch {
    // Sin almacenamiento: la encuesta queda en Ajustes.
  }
}

/** Una apertura más de la app (se llama una vez al montar). */
export function contarApertura(ahora = Date.now()): RegistroEncuesta {
  const registro = leerRegistro(ahora);
  const nuevo = { ...registro, aperturas: registro.aperturas + 1 };
  guardarRegistro(nuevo);
  return nuevo;
}

export function marcarCerrada(encuesta: NombreEncuesta) {
  const registro = leerRegistro();
  guardarRegistro({
    ...registro,
    cerrada: { ...registro.cerrada, [encuesta]: true },
  });
}
